import { IconProps } from '@/types';
import React from 'react';

export const Crossmark = ({
  color = '#3971C0',
  height = '16',
  width = '17',
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.5L4 12.5M4 4.5L12 12.5"
        stroke={color}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
